<template>
<div>
        <div class="subway columns">
        <h2>地铁自动化监测</h2>
        <div class="all">
          <p>
              地铁通常位于软弱破碎岩层，地质稳定性差。如果对地铁隧道变形控制不力，将会出现围岩迅速松弛，发生隧道冒顶坍方、地表沉降、建筑物管线等变形，危及地铁结构本体及周边建 （构）筑物等安全。 
          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>监测地铁隧道、盾构区间、车站结构等地铁结构的形变，确保地铁施工或运营期间的安全。</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>道床沉降（测量机器人/静力水准）</p>
            <p>断面收敛（测量机器人/激光测距仪）</p>
            <p>拱顶沉降（测量机器人）</p>
            <p>隧道壁水平位移（测量机器人）</p>
            <p>气象环境（气象传感器）</p>
            <p>应力应变（应力计、应变计）</p>
            <p>接缝位移（裂缝计）</p>
            <p>隧道垂直度（测量机器人/倾斜计）</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>Topcon MS系列测量机器人</p>
            <p>Topcon DS系列测量机器人</p>
            <p>RT-LRD系列智能测距仪</p>
            <p>RT-DT-5100液压式静力水准</p>
            <p>RT2000-WS三参数气象传感器</p>
            <p>RT-VW-1200振弦式表面应变计</p>
            <p>RT-VW-4100振弦式裂缝计</p>
            <p>RT-DT-6300测斜仪</p>
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>                  
        </div>

        
       
    </div>
     <foot></foot>

</div>

</template>
<style>
.subway {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/solutionpage/subway.vue